import React from 'react';
import SummaryPanel from 'components/common/SummaryPanel';
import { IMovementEnquirySummaryPanel } from './SummaryPanel.properties';
import SummaryTableSchema from '../SummaryPanel/SummaryTableSchema';
import { useMEDispatch } from '../MovementEnquiry.context';
import { MovementEnquiryActionTypes } from '../MovementEnquiry.actions';
import { withStyles } from '@material-ui/core';
import inlineStyles from './SummaryPanel.styles';
import { useRetrieveMovementSummary } from 'api/movementEnquiry/movementEnquiry';

const MovementEnquirySummaryPanel = (props: IMovementEnquirySummaryPanel) => {
    const { classes } = props;
    const contextDispatch = useMEDispatch();
    const params = new URLSearchParams(location.search);
    const ProductId = params.get('ProductId') || 0;
    const MovementId = params.get('MovementId') || 0;
    const LineNumber = params.get('MovementLineNo') || 0;
    const fetchSummaryMutation = useRetrieveMovementSummary();

    const fetchMovementEnquirySummary = React.useCallback(
        async () => {
            const summary = await fetchSummaryMutation.mutateAsync({
                ProductId: Number(ProductId),
                MovementId: Number(MovementId),
                LineNumber: Number(LineNumber)
            });

            return summary?.StockingMovement ?? [];
        },
        [fetchSummaryMutation]
    );

    React.useEffect(
        () => {
            fetchMovementEnquirySummary().then((summary) => {
                if (summary) {
                    contextDispatch({
                        [MovementEnquiryActionTypes.setSummaryPanelData]: summary,
                    });
                }
            });
        },
        []
    );

    return (
        <React.Fragment>
            <SummaryPanel
                loading={fetchSummaryMutation.isLoading}
                data={fetchSummaryMutation?.data?.StockingMovement?.inlineObject ?? []}
                schema={SummaryTableSchema}
                customClassNames={classes.meSummary}
            />
        </React.Fragment>
    );
};

export default withStyles(inlineStyles, { index: 1 })(MovementEnquirySummaryPanel);
